import { State } from '@apps-common/auth/client';

let state: State;

export const setAuthState = (newState: State) => {
  state = newState;
};

export const getAccessToken = () => {
  return state?.user?.accessToken;
};

export const doLogout = () => null;
